import React from 'react';
// Mock data for the dashboard
// User data
export const mockUsers = [{
  id: 'USR001',
  name: 'John Doe',
  email: 'john.doe@example.com',
  status: 'active',
  registrationDate: '2023-05-15',
  lastActive: '2023-06-10',
  accountType: 'Premium'
}, {
  id: 'USR002',
  name: 'Jane Smith',
  email: 'jane.smith@example.com',
  status: 'active',
  registrationDate: '2023-04-22',
  lastActive: '2023-06-09',
  accountType: 'Free'
}, {
  id: 'USR003',
  name: 'Robert Johnson',
  email: 'robert.j@example.com',
  status: 'inactive',
  registrationDate: '2023-03-10',
  lastActive: '2023-05-01',
  accountType: 'Premium'
}, {
  id: 'USR004',
  name: 'Emily Davis',
  email: 'emily.davis@example.com',
  status: 'active',
  registrationDate: '2023-06-01',
  lastActive: '2023-06-10',
  accountType: 'Free'
}, {
  id: 'USR005',
  name: 'Michael Wilson',
  email: 'michael.w@example.com',
  status: 'pending',
  registrationDate: '2023-06-08',
  lastActive: '2023-06-08',
  accountType: 'Free'
}, {
  id: 'USR006',
  name: 'Sarah Brown',
  email: 'sarah.b@example.com',
  status: 'active',
  registrationDate: '2023-02-15',
  lastActive: '2023-06-07',
  accountType: 'Premium'
}, {
  id: 'USR007',
  name: 'David Miller',
  email: 'david.m@example.com',
  status: 'inactive',
  registrationDate: '2023-01-20',
  lastActive: '2023-04-15',
  accountType: 'Free'
}, {
  id: 'USR008',
  name: 'Laura Taylor',
  email: 'laura.t@example.com',
  status: 'active',
  registrationDate: '2023-05-05',
  lastActive: '2023-06-09',
  accountType: 'Premium'
}, {
  id: 'USR009',
  name: 'James Anderson',
  email: 'james.a@example.com',
  status: 'active',
  registrationDate: '2023-04-10',
  lastActive: '2023-06-10',
  accountType: 'Free'
}, {
  id: 'USR010',
  name: 'Patricia Thomas',
  email: 'patricia.t@example.com',
  status: 'pending',
  registrationDate: '2023-06-05',
  lastActive: '2023-06-05',
  accountType: 'Free'
}, {
  id: 'USR011',
  name: 'Richard White',
  email: 'richard.w@example.com',
  status: 'active',
  registrationDate: '2023-03-22',
  lastActive: '2023-06-08',
  accountType: 'Premium'
}, {
  id: 'USR012',
  name: 'Jennifer Clark',
  email: 'jennifer.c@example.com',
  status: 'active',
  registrationDate: '2023-05-18',
  lastActive: '2023-06-09',
  accountType: 'Free'
}] as const;
// User growth data
export const userGrowthData = [{
  name: 'Jan',
  users: 400
}, {
  name: 'Feb',
  users: 600
}, {
  name: 'Mar',
  users: 800
}, {
  name: 'Apr',
  users: 1000
}, {
  name: 'May',
  users: 1200
}, {
  name: 'Jun',
  users: 1500
}, {
  name: 'Jul',
  users: 1800
}];
// User activity data
export const userActivityData = [{
  name: 'Mon',
  active: 120,
  new: 20
}, {
  name: 'Tue',
  active: 132,
  new: 18
}, {
  name: 'Wed',
  active: 145,
  new: 25
}, {
  name: 'Thu',
  active: 140,
  new: 22
}, {
  name: 'Fri',
  active: 135,
  new: 19
}, {
  name: 'Sat',
  active: 90,
  new: 15
}, {
  name: 'Sun',
  active: 85,
  new: 12
}];
// Revenue data
export const revenueData = [{
  name: 'Jan',
  premium: 5000,
  referrals: 2000
}, {
  name: 'Feb',
  premium: 6000,
  referrals: 2200
}, {
  name: 'Mar',
  premium: 7000,
  referrals: 2400
}, {
  name: 'Apr',
  premium: 8000,
  referrals: 2600
}, {
  name: 'May',
  premium: 9000,
  referrals: 2800
}, {
  name: 'Jun',
  premium: 10000,
  referrals: 3000
}];
// Bank integration status
export const bankIntegrationStatus = [{
  name: 'Chase',
  status: 'operational',
  users: 450,
  responseTime: '120ms'
}, {
  name: 'Bank of America',
  status: 'operational',
  users: 380,
  responseTime: '145ms'
}, {
  name: 'Wells Fargo',
  status: 'degraded',
  users: 320,
  responseTime: '210ms'
}, {
  name: 'Citibank',
  status: 'operational',
  users: 290,
  responseTime: '130ms'
}, {
  name: 'Capital One',
  status: 'operational',
  users: 270,
  responseTime: '125ms'
}, {
  name: 'TD Bank',
  status: 'down',
  users: 180,
  responseTime: '350ms'
}, {
  name: 'PNC Bank',
  status: 'operational',
  users: 150,
  responseTime: '140ms'
}];
// Feature usage data
export const featureUsageData = [{
  name: 'Budget Tracking',
  usage: 85
}, {
  name: 'Goal Setting',
  usage: 65
}, {
  name: 'AI Assistant',
  usage: 75
}, {
  name: 'Investment Discovery',
  usage: 45
}, {
  name: 'Loan Comparison',
  usage: 35
}, {
  name: 'Spending Analysis',
  usage: 80
}, {
  name: 'Bank Connections',
  usage: 95
}];
// AI Assistant usage data
export const aiAssistantData = [{
  name: 'Financial Advisor',
  usage: 40
}, {
  name: 'Budget Coach',
  usage: 25
}, {
  name: 'Investment Guide',
  usage: 15
}, {
  name: 'Debt Reducer',
  usage: 20
}];
// System performance data
export const systemPerformanceData = [{
  name: '00:00',
  responseTime: 120,
  errors: 2
}, {
  name: '04:00',
  responseTime: 125,
  errors: 1
}, {
  name: '08:00',
  responseTime: 180,
  errors: 5
}, {
  name: '12:00',
  responseTime: 220,
  errors: 8
}, {
  name: '16:00',
  responseTime: 190,
  errors: 6
}, {
  name: '20:00',
  responseTime: 140,
  errors: 3
}];
// Loan performance data
export const loanPerformanceData = [{
  name: 'Personal Loans',
  applications: 120,
  approvals: 85
}, {
  name: 'Auto Loans',
  applications: 80,
  approvals: 65
}, {
  name: 'Mortgages',
  applications: 60,
  approvals: 42
}, {
  name: 'Student Loans',
  applications: 90,
  approvals: 75
}, {
  name: 'Business Loans',
  applications: 40,
  approvals: 25
}];
// Investment performance data
export const investmentPerformanceData = [{
  name: 'ETFs',
  clicks: 320,
  conversions: 80
}, {
  name: 'Stocks',
  clicks: 250,
  conversions: 60
}, {
  name: 'Mutual Funds',
  clicks: 180,
  conversions: 45
}, {
  name: 'Robo-Advisors',
  clicks: 150,
  conversions: 50
}, {
  name: 'Crypto',
  clicks: 220,
  conversions: 30
}];